import { render, staticRenderFns } from "./SectionDownloadXID.vue?vue&type=template&id=bef79d00&scoped=true"
import script from "./SectionDownloadXID.vue?vue&type=script&lang=ts"
export * from "./SectionDownloadXID.vue?vue&type=script&lang=ts"
import style0 from "./SectionDownloadXID.vue?vue&type=style&index=0&id=bef79d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef79d00",
  null
  
)

export default component.exports